import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider.webp';
import projectImage2 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_2.webp';
import projectImage3 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_3.webp';
import projectImage4 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_4.webp';
import projectImage5 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_5.webp';
import projectImage6 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_6.webp';

import Data_ValeHRP from './Data-ValeHRP';

function Work_ValeHRP() {
    const canonical = 'https://studio.norcat.org/OurWork/vale-hrp';
    const title = 'Vale HRP | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, Vale HRP is a VR training experience that helps workers build hazard recognition skills, situational awareness, and safer decision-making before entering high-risk environments.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the Vale HRP VR training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the Vale HRP VR training project"
            />
            <DetailedHeader
                heading="Preparing Workers for What Lies Below"
                client="Vale Canada"
                service="Virtual Reality"
                date="2024-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=buYVdYX-PWY"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Vale HRP project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'Vale HRP project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'Vale HRP project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'Vale HRP project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'Vale HRP project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'Vale HRP project screenshot 6',
                    },
                ]}
            />

            {Data_ValeHRP.content}
        </>
    );
}

export default Work_ValeHRP;
